export const changeToFullScreen = (element) => {
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen()
  }
}

export const exitFromFullScreen = (doc) => {
  if (doc.exitFullscreen) {
    doc.exitFullscreen()
  } else if (doc.msExitFullscreen) {
    doc.msExitFullscreen()
  } else if (doc.mozRequestFullScreen) {
    document.mozExitFullscreen()
  } else if (doc.mozExitFullscreen) {
    doc.webkitExitFullscreen()
  }
}

export const getDeformationRateIntervalString = (value) => {
  if (value === 0) {
    return ""
  } else if (value === 1) {
    return "greater_than:-5;less_than:5"
  }
  else if (value === 2) {
    return "greater_than:-10;less_than:10"
  }
  else if (value === 3) {
    return "less_than:-10;greater_than:10;percentage:100;logic_operator:or"
  }
  else if (value === 4) {
    return "less_than:-20;greater_than:20;percentage:100;logic_operator:or"
  }
}


